export default __webpack_public_path__ + "static/banner-architect-fcad9eadbe6d5cb213705d39453826d6.jpg";